import { Button, Tooltip } from "@material-ui/core";
import { Delete, Email, ToggleOff, ToggleOn } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  changeStatusNewsletter,
  deleteNewsletter,
  duplicarNewsletter,
  getNewsletters,
} from "../../../../api/newsletter";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
  buttonsStyle,
  dateFormatter,
  imageFormatter,
  substringFormatter,
} from "../../../components/tables/table";
import { getNoticias } from "../../../../api/noticia";
import { getBrevoTemplates, sendBrevoEmail } from "../../../../api/brevo";
import NewsletterUsersSelectDialog from "../../../components/dialogs/NewsletterUsersSelectDialog";
import { Copy } from "lucide-react";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditGestionModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";

function getData(newsletters, templates) {
  let data = [];
  for (let i = 0; i < newsletters.length; ++i) {
    const elem = {};
    elem.asunto = getNonEmpty(newsletters[i].subject);
    elem.nEnvios = newsletters[i].nEnvios;
    if (newsletters[i].isCanva) {
      elem.title = getNonEmpty(newsletters[i].subject);
      elem.template = "Canva";
    } else {
      elem.title = getNonEmpty(newsletters[i].title);
      elem.description = getNonEmpty(newsletters[i].summary);
      elem.template = templates.find(
        (x) => x.id === newsletters[i].templateId,
      )?.name;
    }

    elem.fechaEnvio = newsletters[i].fechaEnvio;
    elem.createdAt = newsletters[i].createdAt;
    elem.active = newsletters[i].active;
    elem.id = newsletters[i]._id;

    data = data.concat(elem);
  }
  return data;
}

function NewslettersPage() {
  const authUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual,
  );
  const canMutateNewsletters =
    canEditGestionModule(authUser?.role) &&
    !isReadOnlyConsultor(authUser?.role);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedNewsletterId, setSelectedNewsletterId] = useState("");

  const [selectedNewsletter, setSelectedNewsletter] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        {canMutateNewsletters && (
        <Tooltip title={"Enviar"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedTemplateId(elem.templateId);
              setSelectedNewsletterId(elem._id);
              setSelectedNewsletter(elem);
              setOpenModal(true);
            }}
          >
            <Email />
          </Button>
        </Tooltip>
        )}
        {canMutateNewsletters && (
        <Tooltip title="Duplicar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedNewsletter(elem);
              setOpenConfirmDialog(4);
            }}
          >
            <Copy />
          </Button>
        </Tooltip>
        )}
        <Tooltip title={"Editar"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-newsletter/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {canMutateNewsletters && (
        <Tooltip title={elem?.active ? "Deshabilitar" : "Habilitar"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedNewsletter(elem);
              setOpenConfirmDialog(1);
            }}
          >
            {elem?.active ? (
              <ToggleOff />
            ) : (
              <ToggleOn style={{ color: "red" }} />
            )}
          </Button>
        </Tooltip>
        )}
        {canMutateNewsletters && (
        <Tooltip title={"DELETE"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedNewsletter(elem);
              setOpenConfirmDialog(2);
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
        )}
      </>
    );
  }

  const columns = [
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      sort: true,
      formatter: dateFormatter,
    },
    {
      dataField: "fechaEnvio",
      text: "Fecha de envio",
      sort: true,
      formatter: dateFormatter,
    },
    {
      dataField: "asunto",
      text: "Asunto",
      sort: true,
      formatter: substringFormatter,
    },
    {
      dataField: "nEnvios",
      text: "Envíos",
      sort: true,
    },
    {
      dataField: "template",
      text: "plantillas",
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  const rowClasses = (row) => {
    let rowClass = "";
    if (row.active === false) rowClass = "inactive-row";
    else
      rowClass =
        new Date(row.date).getTime() < new Date().getTime()
          ? "newsletter-completed-row"
          : "";

    return rowClass;
  };

  const handleSend = async (lista, templateId, newsletterId) => {
    const body = { usersIds: lista, templateId, newsletterId };
    try {
      const res = await sendBrevoEmail(body);
      if (res.status === 200) {
        alertSuccess({
          customMessage: "Newsletter enviada",
        });
        // Refrescar lista para que el contador de envíos se actualice
        setRefresh(true);
      }
    } catch (error) {
      alertError({
        error: error,
        customMessage: "Oooppss...",
      });
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resNewsletters = await getNewsletters();
        const resBrevoTemplates = await getBrevoTemplates();
        const templatesList = Array.isArray(resBrevoTemplates?.data?.templates)
          ? resBrevoTemplates.data.templates
          : [];
        if (resNewsletters.status === 200) {
          setData(resNewsletters.data);
          setFilteredData(getData(resNewsletters.data, templatesList));
          setRefresh(false);
        }
      } catch (error) {
        console.log(error);
        alertError({
          error: error,
          customMessage: "Error al descargar los datos",
        });
        history.push("/dashboard");
      }
    };
    fetchData();
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title={"Lista mailings"}>
          <CardHeaderToolbar>
            {canMutateNewsletters && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-newsletter")}
            >
              Añadir
            </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            pageKey="newslettersPage"
            data={filteredData}
            columns={columns}
            customRowClasses={rowClasses}
          />
        </CardBody>
      </Card>
      <ConfirmDialog
        title={
          selectedNewsletter?.active
            ? "Estas seguro que quieres deshabilitar esta newsletter?"
            : "Estas seguro que quieres habilitar esta newsletter?"
        }
        open={openConfirmDialog === 1}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => {
          changeStatusNewsletter(
            selectedNewsletter._id,
            !selectedNewsletter?.active,
          )
            .then((res) => {
              if (res.status === 200) {
                alertSuccess({
                  title: selectedNewsletter?.active
                    ? "Deshabiliada"
                    : "Habilitada",
                  customMessage: selectedNewsletter?.active
                    ? "Se ha deshabilitado correctamente"
                    : "Se ha habilitado correctamente",
                });
                setRefresh(true);
              }
            })
            .catch((error) => {
              alertError({
                error: error,
                customMessage: selectedNewsletter?.active
                  ? "No se ha podido deshabilitar"
                  : "No se ha podido habilitar",
              });
            });
        }}
      />
      <ConfirmDialog
        title={"Estas seguro que quieres borrar esta newsletter?"}
        open={openConfirmDialog === 2}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => {
          deleteNewsletter(selectedNewsletter._id)
            .then((res) => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({
                  title: "Borrada",
                  customMessage: "Newsletter borrada correctamente",
                });
                setRefresh(true);
              }
            })
            .catch((error) => {
              alertError({
                error: error,
                customMessage: "No se ha podido borrar",
              });
            });
        }}
      />
      <NewsletterUsersSelectDialog
        open={openModal}
        setOpen={setOpenModal}
        handleSend={handleSend}
        templateId={selectedTemplateId}
        newsletterId={selectedNewsletterId}
      />
      <ConfirmDialog
        title={`Estas seguro que quieres duplicar este mailing?`}
        open={openConfirmDialog === 4}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => {
          duplicarNewsletter(selectedNewsletter._id, selectedNewsletter)
            .then((res) => {
              if (res.status === 201) {
                alertSuccess({
                  title: `Duplicado`,
                  customMessage: `Mailing duplicado`,
                });
                setRefresh(true);
              }
            })
            .catch((error) => {
              alertError({
                error: error,
                customMessage: `No se ha podido duplicar el mailing.`,
              });
            });
        }}
      />
    </>
  );
}
export default NewslettersPage;
